import { Shinsei, Kosyoku } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit(form: Shinsei) {

  let kosyoku: Kosyoku[] = reactive([{
    shinsei_date: null,
  }]);

  if(form.kosyoku){
    kosyoku = form.kosyoku;
  }else{
    form.kosyoku = kosyoku;
  }

  return {
    kosyoku
  }
}
